import Seo from "@/components/Seo";
import { SITE } from "@/lib/site";

export default function LegalPage({ title, description, updated, intro, children }) {
  return (
    <article className="legal-page">
      <Seo title={`${title} · ${SITE.name}`} description={description} />

      <header className="border-b border-ink col-rules">
        <div className="mx-auto max-w-[1200px] px-5 md:px-8 py-10 md:py-14">
          <p className="eyebrow text-ink/60">Legal</p>
          <h1 className="display text-[42px] md:text-[68px] leading-none mt-4">{title}</h1>
          <p className="text-lg text-ink/75 max-w-[62ch] mt-6">{intro}</p>
        </div>
      </header>

      <div className="mx-auto max-w-[1200px] px-5 md:px-8 py-9 md:py-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
        <aside className="md:col-span-3 md:sticky md:top-24 md:self-start border-t border-ink pt-4 text-sm text-ink/65">
          <p className="eyebrow text-ink/50">Effective</p>
          <p className="mt-2">{updated}</p>
          <p className="mt-6">
            Questions?<br />
            <a href={`mailto:${SITE.email}`} className="ember-link text-ember-deep">{SITE.email}</a>
          </p>
        </aside>
        <div className="md:col-span-9 legal-copy">{children}</div>
      </div>
    </article>
  );
}
